<template>
  <div>
    <KwAlert
      v-if='hasGlobalError'
      class="alert"
      type='error'
      slot='panel-alert'
    >
      <span v-html="i18n('loading_error_cc__notice')"></span>
    </KwAlert>
    <slot />
  </div>
</template>

<script>
import KwAlert from '@kiwitaxi/vue-components/dist/KwAlert';
import { i18n } from '@/mixins';

export default {
  name: 'KwAppError',
  components: {
    KwAlert,
  },
  mixins: [i18n],
  computed: {
    hasGlobalError() {
      return this.$store.getters.hasGlobalError;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/KwAppError.vue